import { Flex } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { getAvatarById } from "src/modules/avatar/duck/selectors";
import { Activities } from "src/modules/activity-log/activity";
import { useParentStation } from "src/modules/parent-station/ParentStation/Context";
import { getAppValue } from "src/utils/environment";
import Sleeping from "./Sleeping";
import Awake from "./Awake";
import Motion from "./Motion";

export default function AudioMode({
  lastNoiseBefore,
  toggleActivityLog,
  noiseMeter,
  lastMotionBefore,
  monitoringStatusBar,
  isInDetachMode,
  activity,
  jid,
  isInTileView,
  avatarSize,
  showSmallAvatar,
  setAnimationControls,
  isMultiRoom,
  avatarId
}) {
  const parentStation = useParentStation();
  const avatar = useSelector((state) => getAvatarById(state, avatarId));

  const { isBabyStationFamilyDevice } = parentStation;
  const commonProps = {
    isInDetachMode,
    selectedAvatar: isBabyStationFamilyDevice({ jid }) ? avatar : null,
    avatarSize,
    showSmallAvatar,
    isInTileView,
    isMultiRoom,
    jid
  };

  return (
    <>
      <Flex
        width="100%"
        flexDirection="column"
        bg={
          activity === Activities.AWAKE
            ? "warningBase"
            : activity === Activities.MOTION
            ? getAppValue({ bibino: "primaryBackground", barkio: "surface" })
            : "transparent"
        }
        justifyContent={isInDetachMode ? "center" : "normal"}
        pt={isInDetachMode ? "0px" : "12px"}
        px={isInTileView ? "65px" : "14px"}
        height="100%"
        flex="1 1 auto"
      >
        {monitoringStatusBar}
        {activity === Activities.SLEEPING && (
          <Sleeping
            lastNoiseBefore={lastNoiseBefore}
            lastMotionBefore={lastMotionBefore}
            toggleActivityLog={toggleActivityLog}
            setAnimationControls={setAnimationControls}
            {...commonProps}
          />
        )}
        {activity === Activities.AWAKE && <Awake noiseMeter={noiseMeter} {...commonProps} />}
        {activity === Activities.MOTION && <Motion {...commonProps} />}
      </Flex>
    </>
  );
}
